module.exports = __webpack_public_path__ + "static/media/onboarding-banner.5a3ceb0e.gif";